<!-- New create/edit button -->
<div [ngClass]="{ 'has-edit-button': isEditMode }">
  <!-- edit button -->
  <ng-container
    *ngIf="isEditMode"
    [brManageContentButton]="document"
    documentTemplateQuery="new-InteractiveMediaCardGrid-document"
    folderTemplateQuery="new-InteractiveMediaCardGrid-folder"
    parameter="document"
    [relative]="false"
    root=""
  >
  </ng-container>
  <!-- has document -->
  <div
    *ngIf="interactiveMediaCards?.length"
    [ngClass]="{ 'has-edit-button': isEditMode }"
    [edsSpacing]="marginBottom === 'auto' ? 'xl' : marginBottom"
  >
    <eds-interactive-media-card-grid
      [theme]="cardTheme"
      [hintMessage]="hintMessage"
      [hideAnimation]="hideAnimation"
      (isAnimationOff)="setAnimationFlagStatus($event)"
      [cards]="interactiveMediaCards"
    >
      <ng-container *ngIf="interactiveMediaCards?.length">
        <eds-interactive-media-card
          *ngFor="let card of interactiveMediaCards"
          edsSpacing="lg"
          [title]="card.title"
          [subTitle]="card.richText.value"
          [link]="card.titleLink?.url"
          [isNewWindow]="card.titleLink?.target == '_blank'"
          [externalLink]="card.titleLink?.external"
          [isAnimationOff]="isAnimationOffFlag"
        >
          <eds-interactive-media-card-image
            frontCard
            *ngIf="card.cardType !== 'question'"
            [imgSrc]="card.frontCardImageUrl"
            [imgAltText]="card.frontCardImageAltText"
            [imgFallbackSrc]="card.imgFallbackSrc"
            [cardType]="card.cardType"
          ></eds-interactive-media-card-image>
          <eds-interactive-media-card-content
            frontCard
            *ngIf="card.cardType === 'question'"
            [content]="card?.strippedContentFrontCardQuestion"
            theme="white"
            [isAnimationOff]="isAnimationOffFlag"
            cardSlot="front"
          ></eds-interactive-media-card-content>
          <eds-interactive-media-card-content
            backCard
            [content]="card?.strippedContentBackCardContent"
            [theme]="cardTheme"
            [isAnimationOff]="isAnimationOffFlag"
            [link]="card.backCardLink?.url"
            [isNewWindow]="card.backCardLink?.target == '_blank'"
            [externalLink]="card.backCardLink?.external"
          ></eds-interactive-media-card-content>
        </eds-interactive-media-card>
      </ng-container>
    </eds-interactive-media-card-grid>
  </div>

  <!-- no document -->
  <div
    *ngIf="isEditMode"
    edsPadding
    [edsPaddingBottom]="padding"
    [edsPaddingTop]="padding"
    edsSpacing="xxl"
    class="no-document"
  >
    <div edsGrid class="no-document__component">
      <div class="no-document__overlay">
        Click to configure <strong>Interactive Media Cards Grid</strong>
      </div>
    </div>
  </div>
</div>
